<template>
  <div class="bg-white vform position-relative">
    <div v-show="loading" class="load-bg">
      <span v-show="loading">
        <i class="spin ml-4" />
      </span>
    </div>
    <div class="row m-4 justify-content-center">
      <div class="col-lg-9 bg-white py-4">
        <div class="container mt-4 pt-4">
          <div class="text-center">
            <div>LOYALTY PTS</div>
            <div v-if="dbuser">{{(dbuser.RewardPoints?dbuser.RewardPoints:0)| formatNumber}}</div>
          </div>
          <hr />
          <div class="row">
            <div class="col-6 text-success text-center">
              <div>PTS EARNED</div>
              <div
                v-if="dbuser"
              >+ {{(dbuser.EarnedRewardPoints?dbuser.EarnedRewardPoints:0)| formatNumber}}</div>
            </div>
            <div class="col-6 text-red text-center">
              <div>PTS SPENT</div>
              <div
                v-if="dbuser"
              >- {{(dbuser.SpentRewardPoints?dbuser.SpentRewardPoints:0)| formatNumber}}</div>
            </div>
          </div>
          <div v-show="error" class="w-100 mt-4">
            <div class="alert alert-red" role="alert">
              <strong>{{ error }}</strong>
            </div>
          </div>
          <div v-show="success" class="w-100 mt-4">
            <div class="alert alert-success" role="alert">
              <strong>Order placed successfully</strong>
            </div>
          </div>
          <hr />
        </div>
        <div class="container">
          <div v-for="(order, index) in pageOrders" :key="index" class="row">
            <div class="row col-sm-12 order-items ml-5">
              <div class="order-item-details col-sm-7">
                <div>Order No.</div>
                <div>{{(order.OrderNumber?'#':'')}}{{order.OrderNumber}}</div>
              </div>
              <div class="col-sm-4 text-right mr-5">
                <div class="color-gray fdate" v-html="getCreateDate(order)" />
                <div class="order-item-cost padding-5-left">
                  <span
                    class="text-red"
                    v-if="order && order.RedeemPoints>0"
                  >&nbsp;-{{order.RedeemPoints | formatNumber}} pts</span>
                  <span
                    class="text-success"
                    v-if="order && order.RewardPoints>0"
                  >&nbsp;+{{order.RewardPoints | formatNumber}} pts</span>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <hr />
            </div>
          </div>
          <div v-if="pageOrders.length == 0">
            <message message="No order available" />
          </div>
        </div>
        <div class="order-pagination">
          <pagination
            v-model="page"
            :records="records"
            :per-page="perPage"
            :options="options"
            @paginate="paginateCallback"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "vue-pagination-2";
import shared from "../../sharedscripts/user/Loyalty.js";
import Message from "./../shared/Message";
import { mapGetters } from "vuex";
export default {
  components: {
    Pagination,
    Message
  },
  data() {
    return {
      page: 1,
      perPage: 3,
      records: 0,
      options: {
        theme: "bootstrap4",
        chunksNavigation: "scroll",
        texts: {
          count: "",
          prev: "prev"
        }
      },
      orders: [],
      pageOrders: [],
      loading: false,
      error: "",
      success: false,
      storeClosed: false
    };
  },
  computed: {
    ...shared.computed,
    ...mapGetters(["desktopStyles", "currentStoreDoc"])
  },
  watch: {
    user(newValue) {
      if (newValue) {
        this.initOrders(this.currentStoreDoc.ID);
      }
    }
  },
  created() {
    if (this.user) {
      this.initOrders(this.currentStoreDoc.ID);
    }
  },
  mounted() {
    this.setStoreLoaded();
  },
  methods: {
    ...shared.methods
  }
};
</script>